import React, { useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Paper, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Draggable, {  } from 'react-draggable';

export const _ICON_EXIT = (<CloseIcon />);

export type TPositionAlign = "left" | "center" | "right";

export const _DEFAULT_MAX_HEIGHT_PANEL_LAYERS = 'calc(100vh - 100px)';
export const _DEFAULT_TOP_PANEL_LAYERS = '57px';

interface IPanelBaseProps {
    title: string,
    colorTitle?: string,
    colorBar: string,
    width: string,
    top?: string,
    spaceRight?: string,
    resizeable?: boolean,
    isDragged?: boolean,
    zIndex?: number,
    positionAlign: TPositionAlign,
    showTitle?: boolean,
    showExpanded?: boolean,
    spaceToolbar?: boolean,
    iconBar?: JSX.Element,
    clickClosePanel(): any
}

export const PanelBase: React.FC<IPanelBaseProps> = ({
    title,
    colorTitle,
    colorBar,
    width,
    top = _DEFAULT_TOP_PANEL_LAYERS,
    spaceRight,
    resizeable = false,
    isDragged = true,
    zIndex = 1000,
    positionAlign,
    showTitle = true,
    showExpanded = true,
    spaceToolbar,
    iconBar,
    clickClosePanel,
    children
}) => {

    const vSpaceToolBar = spaceToolbar ? '70px' : '15px';

    const vFloat = positionAlign === 'center' ? 'none' : positionAlign;
    const vRight = spaceRight ?? (positionAlign === 'right' ? vSpaceToolBar : positionAlign === 'center' ? '0px' : 'none');
    const vLeft = positionAlign === 'left' ? vSpaceToolBar : positionAlign === 'center' ? '0px' : 'none';
    const vMarginLeft = positionAlign === 'center' ? 'auto' : 'none';
    const vMarginRight = positionAlign === 'center' ? 'auto' : 'none';

    const isResizeable = !showTitle || showExpanded ? false : resizeable;

    // calcula o top do painel para garantir que o drag mova até no máximo o _DEFAULT_TOP_PANEL_LAYERS
    const nDefaultTop = parseInt(_DEFAULT_TOP_PANEL_LAYERS.replace('px', '').replace('rem', ''));
    let nTop = parseInt(top.replace('px', '').replace('rem', ''));

    const useStyles = makeStyles((theme) =>
        createStyles({
            root: {
                flexGrow: 1
            },
            paperPanel: {
                position: 'absolute',
                zIndex: zIndex,
                top: top,
                width: width,
                float: vFloat,
                right: vRight,
                left: vLeft,
                marginLeft: vMarginLeft,
                marginRight: vMarginRight,
                borderRadius: 10,
                resize: isResizeable ? 'both' : 'none',
                overflow: isResizeable ? 'auto' : 'hidden'
            },
            buttonClose: {
                marginLeft: 'auto',
                marginRight: '-20px'
            },
            buttonExpand: {
                marginLeft: 'auto',
                marginRight: '5px',
            },
            bar: {
                backgroundColor: colorBar,
                borderTopLeftRadius: 10,
                borderTopRightRadius: 10,
                cursor: 'move'
            },
            iconBar: {
                marginLeft: '-15px'
            },
            titleBar: {
                marginLeft: '10px',
                color: colorTitle
            },
            titleButtons: {
                marginLeft: 'auto'
            }
        }),
    );

    const styles = useStyles();

    const [expanded, setExpanded] = useState(true);

    const PaperPanel = (
        <Paper className={styles.paperPanel} elevation={14}>
            {
                showTitle && (
                    <div className={styles.root} id='draggable-dialog-title'>
                        <AppBar position="static" className={styles.bar} elevation={1}>
                            <Toolbar variant="dense">
                                <div className={styles.iconBar}>
                                    {iconBar}
                                </div>
                                <Typography variant="h6" color="inherit" className={styles.titleBar}>
                                    {title}
                                </Typography>
                                {
                                    showExpanded &&
                                    <div className={styles.titleButtons}>
                                        <IconButton
                                            className={styles.buttonExpand}
                                            onClick={() => setExpanded(!expanded)}
                                            color="inherit"
                                        >
                                            {
                                                expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />
                                            }
                                        </IconButton>
                                        <IconButton
                                            className={styles.buttonClose}
                                            onClick={() => clickClosePanel()}
                                            color="inherit"
                                        >
                                            {_ICON_EXIT}
                                        </IconButton>
                                    </div>
                                }

                            </Toolbar>
                        </AppBar>
                    </div>
                )
            }
            {
                expanded && children
            }
        </Paper>
    );

    return (

        <>
            {
                isDragged && showTitle ? (
                    <Draggable
                        handle="#draggable-dialog-title"
                        cancel={'[class*="MuiDialogContent-root"]'}
                        bounds={{ top: nDefaultTop - nTop }}
                    >
                        {PaperPanel}
                    </Draggable >
                ) : (
                    <>
                        {PaperPanel}
                    </>
                )

            }

        </>

    );
}









